module.exports = __webpack_public_path__ + "static/product_back-a05c65a1c1f13e8da5aa94cfda164f2d.png";